import axios from 'axios'
import { escapeRegExp } from '$func/utils'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const SHORTENER_API = import.meta.env.VITE_LINK_SHORTNER_API as string
const SHORTENER_HOST = new URL(SHORTENER_API).host

export const URL_SHORTENER_PATTERN = new RegExp(
  `^(https?:\\/\\/|)${escapeRegExp(SHORTENER_HOST)}/\\w{5,}\\/?$`,
  'gm',
)

export function createShortLink(target: string) {
  return Promise.race([
    axios
      .post<{ link: string }>(SHORTENER_API, { target })
      .then(res => res.data.link)
      .catch(() => target),

    new Promise<string>(r => setTimeout(r, 5000, target)),
  ])
}

export async function getShortLinkTarget(link: string) {
  try {
    const response = await axios.get<{ target: string }>(`${link}+`)
    return response.data.target
  } catch (e) {
    return null
  }
}
